import React, { CSSProperties } from 'react';
import useTranslate from '../../../../customHooks/useTranslate';
import {
    getSupplierTaxCalculationRuleTypeSubTypes,
    supplierTaxCalculationRuleTypeFrequencyIcons,
    supplierTaxCalculationRuleTypeSubjectIcons,
    UnknownOptionIcons,
} from '../../../../utils/taxes/taxesListUtils';
import Tooltip from '../../../../muiComponents/Tooltip';
import Icon from '../../../../muiComponents/Icon';
import { capitalize } from '../../../../utils/usefulFunctions';

interface ISupplierTaxCalculationRuleTypeIconProps {
    entityKey: string;
    type: 'subject' | 'frequency';
    color: string;
}

const SupplierTaxCalculationRuleTypeIcon = ({
    entityKey,
    type,
    color,
}: ISupplierTaxCalculationRuleTypeIconProps) => {
    const translate = useTranslate();
    const supplierTaxCalculationRuleTypeSubIcons =
        getSupplierTaxCalculationRuleTypeSubTypes(entityKey);

    const typeIcon = {
        subject: supplierTaxCalculationRuleTypeSubIcons.subject
            ? supplierTaxCalculationRuleTypeSubjectIcons[
                  supplierTaxCalculationRuleTypeSubIcons.subject as keyof typeof supplierTaxCalculationRuleTypeSubjectIcons
              ]
            : UnknownOptionIcons.SUPPLIER_TAX_CALCULATION_RULE_SUBJECT_TYPE,
        frequency: supplierTaxCalculationRuleTypeSubIcons.frequency
            ? supplierTaxCalculationRuleTypeFrequencyIcons[
                  supplierTaxCalculationRuleTypeSubIcons.frequency as keyof typeof supplierTaxCalculationRuleTypeFrequencyIcons
              ]
            : UnknownOptionIcons.SUPPLIER_TAX_CALCULATION_RULE_FREQUENCY_TYPE,
    };

    const outlinedStyles: CSSProperties = {
        color,
        backgroundColor: 'transparent',
        border: `1px solid ${color}`,
    };

    const text = supplierTaxCalculationRuleTypeSubIcons[type];

    return (
        <Tooltip
            title={`${translate(
                type === 'subject' ? 'applies_by' : 'frequency'
            )}: ${supplierTaxCalculationRuleTypeSubIcons[type] || ''}`}
        >
            <div
                className='flex gap-5 flex-align-center tag__container'
                style={outlinedStyles}
            >
                <Icon iconName={typeIcon[type]} />
                <p
                    className='text-capitalize'
                    style={{ fontWeight: 600, fontSize: '12px' }}
                >
                    {capitalize(text)}
                </p>
            </div>
        </Tooltip>
    );
};

export default SupplierTaxCalculationRuleTypeIcon;
